import React, { createContext, useContext, useState, useEffect } from "react"

const AuthModalContext = createContext()

export const AuthModalProvider = ({ children }) => {
  const [showAuthModal, setShowAuthModal] = useState(false)

  // Register a window-level closer so gatsby-browser.js can call it from
  // onRouteUpdate — the only 100% reliable hook for Gatsby page transitions.
  useEffect(() => {
    if (typeof window !== "undefined") {
      window.__stepwiseCloseAuthModal = () => setShowAuthModal(false)
    }
    return () => {
      if (typeof window !== "undefined") {
        delete window.__stepwiseCloseAuthModal
      }
    }
  }, [])

  return (
    <AuthModalContext.Provider value={{ showAuthModal, setShowAuthModal }}>
      {children}
    </AuthModalContext.Provider>
  )
}

export const useAuthModal = () => useContext(AuthModalContext)
